export const rejectDuplicateName =
  (existingNames: string[], message: string) => (file: File) =>
    Promise.resolve(
      existingNames.includes(file.name) ? { message, code: '409' } : null,
    );
